import React from 'react';
import { formatNumber2 } from "utils/currencyFormat";
import { getDate } from "utils/formatDate";

const styles = {
    cell: { border: "1px solid #EEE", padding: "8px 5px", verticalAlign: "middle", fontSize: "10pt" },
    headerCell: { border: "1px solid #EEE", padding: "8px 5px", fontWeight: "bold", color: "#000000", verticalAlign: "middle", textAlign: "center", fontSize: "10pt", backgroundColor: "#f8f8f8" },
    textLeft: { textAlign: "left" },
    textCenter: { textAlign: "center" },
    textRight: { textAlign: "right" },
    colorRed: { color: '#FF5170' },
    colorGreen: { color: '#00B69B' }
};
const GiaoDichModelType = {
    None: 0,
    ChoVay: 1,
    NhanVay: 2,
    ThuChi: 3
};
const PhieuInGiaoDich = React.forwardRef((props, ref) => {
    const { listGiaoDich } = props;

    const renderTableData = () => {
        if (listGiaoDich && listGiaoDich.Transactions && listGiaoDich.Transactions.length > 0) {
            return listGiaoDich.Transactions.map((item, index) => {

                const soTien = item.GiaoDichValue ?? 0;
                let soTienStyle = styles.textRight;
                if (soTien < 0) {
                    soTienStyle = { ...soTienStyle, ...styles.colorRed };
                } else if (soTien > 0) {
                    soTienStyle = { ...soTienStyle, ...styles.colorGreen };
                }
                let maGiaoDichStyle = { ...styles.cell, ...styles.textLeft };
                if (item.DetailType === GiaoDichModelType.ChoVay) {
                    maGiaoDichStyle = { ...maGiaoDichStyle, ...styles.colorGreen };
                }
                return (
                    <tr key={item.GiaoDichId || index}>
                        <td style={{ ...styles.cell, ...styles.textCenter }}>{index + 1}</td>
                        <td style={maGiaoDichStyle}>{item.GiaoDichCode}</td>
                        <td style={{ ...styles.cell, ...styles.textLeft }} dangerouslySetInnerHTML={{ __html: item.Type }}></td>
                        <td style={{ ...styles.cell, ...styles.textLeft }}>{item.GiaoDichUserName}</td>
                        <td style={{ ...styles.cell, ...styles.textLeft, ...styles.colorGreen }}>{item.GiaoDichName}</td>
                        <td style={{ ...styles.cell, ...styles.textCenter }}>{getDate(item.GiaoDichTime)}</td>
                        <td style={{ ...styles.cell, ...styles.textCenter }}>{getDate(item.ThuChiTime)}</td>
                        <td style={{ ...styles.cell, ...soTienStyle }}>
                            {formatNumber2(soTien)}
                        </td>
                    </tr>
                );
            });
        } else {
            return (
                <tr>
                    <td colSpan="8" style={{ ...styles.cell, ...styles.textCenter }}>Không có dữ liệu.</td>
                </tr>
            );
        }
    };

    return (
        <div ref={ref} style={{ padding: '20px', fontSize: "10pt", color: "#000000", backgroundColor: "#fff" }}>
            <table style={{ width: "100%", borderCollapse: 'collapse' }}>
                <tbody>
                    <tr>
                        <td style={{ textAlign: "center", width: "100%", fontWeight: "bold", fontSize: "18px", color: "#000000", padding: "10px 0 20px 0", textTransform: "uppercase" }}>
                            BÁO CÁO GIAO DỊCH TRONG NGÀY
                        </td>
                    </tr>
                </tbody>
            </table>
            <table style={{ width: "100%", borderCollapse: "collapse", border: "1px solid #EEE", color: "#000000", marginTop: "10px" }}>
                <tr>
                    <th style={{ ...styles.headerCell, width: '5%' }} className="color-do-bold">
                        STT <br /> [{formatNumber2(listGiaoDich.TotalRow)}]
                    </th>
                    <th style={{ ...styles.headerCell, width: '12%' }}>Mã giao dịch</th>
                    <th style={{ ...styles.headerCell, width: '15%' }}>Loại</th>
                    <th style={{ ...styles.headerCell, width: '18%' }}>Nhân viên</th>
                    <th style={{ ...styles.headerCell, width: '15%' }}>Khách hàng</th>
                    <th style={{ ...styles.headerCell, width: '10%' }}>Ngày tạo</th>
                    <th style={{ ...styles.headerCell, width: '10%' }}>Ngày thu/chi</th>
                    <th style={{ ...styles.headerCell, width: '15%' }} className="color-do-bold">
                        Số tiền <br /> [{formatNumber2(listGiaoDich.TotalValue)}]
                    </th>
                </tr>
                {renderTableData()}
            </table>
        </div>
    );
});

export default PhieuInGiaoDich;